import { useEffect, useState } from 'react'
import { getBarSize } from '../helpers'

export const useBarSize = (offset: number, dataCount?: number) => {
  const [width, setWidth] = useState(0)
  const [barSize, setBarSize] = useState(0)

  const onResize = (width: number) => {
    setWidth(width)
    const newBarSize = getBarSize(width + offset, dataCount)
    setBarSize(newBarSize)
  }

  useEffect(() => {
    onResize(width)
  }, [dataCount])

  return [barSize, onResize] as Parameters<
    (barSize: number, onResize: (width: number, height: number) => void) => void
  >
}
